export const LEAD_FORMS = "LEAD_FORMS";
export const GENERATED_HTML = "GENERATED_HTML";
export const LOADING = "LOADING";
